module.exports = __webpack_public_path__ + "static/media/portafolioVanilla.13644842.png";